var a = /* @__PURE__ */ ((r) => (r.CUSTOM = "custom", r.SQUARE = "square", r.PORTRAIT = "portrait", r.LANDSCAPE = "landscape", r.WIDE = "wide", r.COVER = "cover", r.CIRCLE = "circle", r))(a || {});
export {
  a as Aspect
};
